export default "__VITE_ASSET__BbcGgWgj__"